import * as React from 'react';

import { TPublicWebV1SearchResponse_MlRanking } from '../../../../../../common/repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { ITrackOfferActionsProps } from '../../../../../../common/types/tracking';
import { trackOfferCardShowOnMap } from '../../../tracking';

interface IUseShowTrackingParams {
  trackingProps: ITrackOfferActionsProps;
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined;
  mlSearchSessionGuid: string | null | undefined;
}

export function useShowTracking({ trackingProps, mlRanking, mlSearchSessionGuid }: IUseShowTrackingParams) {
  const trackedOfferIdRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (trackedOfferIdRef.current === trackingProps.offerId) {
      return;
    }

    trackedOfferIdRef.current = trackingProps.offerId;
    trackOfferCardShowOnMap(trackingProps, mlRanking, mlSearchSessionGuid);
  }, [trackingProps, mlRanking, mlSearchSessionGuid]);
}
